import {AxiosResponse} from "axios";
import AxiosApiInstance, {APIBase} from "../../../AxiosApiInstance";

export interface SetStatusByEmailItem {
  email: string;
  status?: string;
  // Уровень (MSc/PhD) — дизамбигуатор одноимённых программ магистратуры/аспирантуры; сам не пишется.
  level?: string;
  // Реквизиты, применяемые при переходе в approved/validated: программа и направление/специальность.
  program?: string;
  direction?: string;
}

export interface SetStatusByEmailRequest {
  default_status?: string;
  items: SetStatusByEmailItem[];
}

export interface SetStatusByEmailReportSummary {
  total: number;
  changed: number;
  not_found: number;
  skipped: number;
  invalid: number;
  warnings: number;
}

export interface SetStatusByEmailChanged {
  email: string;
  application_id: string;
  from: string;
  to: string;
  // Проставленные реквизиты (для перехода в approved/validated), иначе null.
  program?: string | null;
  direction?: string | null;
}

export interface SetStatusByEmailSkipped {
  email: string;
  application_id: string;
  current: string;
  target: string;
  reason: "already_in_target" | "ineligible_transition" | "required_missing" | "error" | string;
  // Теги незаполненных обязательных вопросов (для reason === "required_missing").
  missing?: string[];
}

export interface SetStatusByEmailInvalid {
  // Строка не применена вовсе (email/статус невалидны).
  email: string;
  value: string;
  reason: "bad_email" | "unknown_status" | string;
}

export interface SetStatusByEmailWarning {
  // Статус сменён (строка есть в changed), но соответствующий реквизит не проставлен — с причиной.
  email: string;
  value: string;
  reason:
    | "requisites_status_not_applicable"
    | "unknown_program"
    | "ambiguous_program"
    | "unknown_direction"
    | "direction_mismatch"
    | "ambiguous_prog_title"
    | string;
}

export interface SetStatusByEmailReport {
  summary: SetStatusByEmailReportSummary;
  changed: SetStatusByEmailChanged[];
  not_found: string[];
  skipped: SetStatusByEmailSkipped[];
  invalid: SetStatusByEmailInvalid[];
  warnings: SetStatusByEmailWarning[];
}

export const ApiBackCampaignsApplicationsSetStatusByEmailPost: (campaign_pk: string, payload: SetStatusByEmailRequest) => Promise<AxiosResponse<SetStatusByEmailReport>> = (campaign_pk, payload) => {
  return AxiosApiInstance.post(`${APIBase}back/campaigns/${campaign_pk}/applications/set_status_by_email/`, payload);
};

export default ApiBackCampaignsApplicationsSetStatusByEmailPost;
